import { render, staticRenderFns } from "./Coach.vue?vue&type=template&id=a5ca8f82&scoped=true&"
import script from "./Coach.vue?vue&type=script&lang=js&"
export * from "./Coach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ca8f82",
  null
  
)

export default component.exports